// IMPORT CSS
import '../../sass/components/_footer.scss'

// IMPORT CUSTOM LIBRARIES
import Loader from "../components/loader";
import { headerGlobal } from "../components/header";

const header = document.querySelector('.header') as HTMLElement;
const loader = new Loader();
let timeOut: any;

// Loader functionality
window.addEventListener('load', () => {
	headerGlobal()
	loader.hide()
	clearTimeout(timeOut);
})

timeOut = setTimeout(() => {
	loader.hide()
}, 5000)

// Header functionality
window.addEventListener('scroll', function (e) {
	if (window.scrollY >= 200) header.classList.add('bkBlack')
	else header.classList.remove('bkBlack')
})